<template>
  <div v-editable="blok" :class="['logotypes', `logotypes--${alignment}`]">
    <StoryblokComponent
      v-for="childBlok in blok.logos"
      :key="childBlok._uid"
      v-editable="blok"
      :blok="childBlok"
    />
  </div>
</template>

<script lang="ts" setup>
import type { SbLogotypesStoryblok } from '@/types'
interface Props {
  blok: SbLogotypesStoryblok
}
const props = defineProps<Props>()
const alignment = computed(() => {
  return props.blok.alignment || 'center'
})
</script>

<style lang="scss" scoped>
.logotypes {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &--center {
    justify-content: center;
    margin: 0;

    @media (min-width: $breakpoint-lg) {
      margin: 0 85px;
    }

    & > div {
      margin: 18px 30px;
    }
  }

  &--center-marginless {
    @extend .logotypes--center;

    @media (min-width: $breakpoint-lg) {
      margin: 0;
    }
  }

  &--left {
    justify-content: center;

    @media (min-width: $breakpoint-md) {
      justify-content: flex-start;
    }

    & > div {
      margin: 0 20px 48px;

      @media (min-width: $breakpoint-md) {
        margin: 0 60px 60px 0;
      }
    }
  }

  &--right {
    justify-content: center;

    @media (min-width: $breakpoint-md) {
      justify-content: flex-end;
    }

    & > div {
      margin: 0 20px 48px;

      @media (min-width: $breakpoint-md) {
        margin: 0 0 60px 60px;
      }
    }
  }

  & > div {
    display: inline-block;
  }
}
</style>
